module.exports = __webpack_public_path__ + "media/images/brand/tiktok_link-d8da1b18c29d8ce11a7d479be6347222.svg";